import { FreightPickupWindowRowSchema } from "@redotech/redo-fulfillment-common/freight/freight-pickup-window";
import { plainTime } from "@redotech/rpc/ext";
import * as z from "zod";

export const createFreightPickupWindow = {
  name: "createFreightPickupWindow" as const,
  input: z.object({
    name: z.string(),
    pickupReadyTime: plainTime(),
    pickupCloseTime: plainTime(),
    isDefault: z.boolean().optional(),
  }),
  output: FreightPickupWindowRowSchema,
};
